import { IAccount } from '@ViewModels';
import { AccountDetails } from '../../containers/account/AccountDetails';

interface IAccountDetailsTabContentOverviewProps {
	hideWebsiteSection?: boolean;
	hideAdsSection?: boolean;
	hideCustomContentSection?: boolean;
	externalEditMode?: boolean;
	onEditModeChange?: (isEditMode: boolean) => void;
	companyNameOverride?: string;
	onAccountUpdated?: (account: IAccount) => void;
	lastSavedAccount?: IAccount;
}

export function AccountDetailsTabContentOverview({
	hideWebsiteSection,
	hideAdsSection,
	hideCustomContentSection,
	externalEditMode,
	onEditModeChange,
	companyNameOverride,
	onAccountUpdated,
	lastSavedAccount,
}: IAccountDetailsTabContentOverviewProps) {
	return (
		<AccountDetails
			hideTabView
			hideHeader
			hideWebsiteSection={hideWebsiteSection}
			hideAdsSection={hideAdsSection}
			hideCustomContentSection={hideCustomContentSection}
			externalEditMode={externalEditMode}
			onEditModeChange={onEditModeChange}
			companyNameOverride={companyNameOverride}
			onAccountUpdated={onAccountUpdated}
			lastSavedAccount={lastSavedAccount}
		/>
	);
}
